import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'
import { propEq } from 'ramda'
import useRole from '@/hooks/use-role'
import useCurrentSession from '@/hooks/use-current-session'
import { Button } from '@/components/button'

const isDraft = propEq('state_machine', 'draft')

const TableContentButton = styled(Button)`
  width: 120px;
  height: 34px;
  justify-content: center;
  align-self: center;
`

const ActionButton = ({ contract, packageFile, order }) => {
  const history = useHistory()
  const { t } = useTranslation()
  const role = useRole()

  const user = useCurrentSession()
  const state_machine = packageFile?.state_machine
  const isContractCreated = state_machine === 'created'
  const isContractSent = state_machine === 'sent'

  const hasSigned = !!contract.signatures?.find(signature => signature.userId === user.id)
  const isContractSentNotSigned = isContractSent && !hasSigned

  const isDisabled = !isContractCreated && !isContractSent

  const viewContract = () => {
    const getNewUrl = (role, contract) => {
      const where = role === 'tenant' ? 'rental' : 'listing'
      if (isDraft(contract))
        return `/listing/${contract?.listing_id}/contract/create/${
          contract?.listing_contract_id || ''
        }`
      return `/${where}/${contract?.listing_id}/contract/${contract?.id}`
    }
    history.push(getNewUrl(role, contract))
  }

  if (isContractSentNotSigned) {
    return (
      <TableContentButton
        onClick={viewContract}
        disabled={isDisabled}
        theme="primary"
        size="small"
        space="none"
      >
        {t('l.contract_manager.documents.sign.button', 'Sign')}
      </TableContentButton>
    )
  }

  return (
    <TableContentButton theme="secondary" onClick={viewContract} size="small" space="none">
      {t('l.contract_manager.documents.view.button', 'View')}
    </TableContentButton>
  )
}

export default ActionButton
